import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../core/data/redux/store';
import {createEsicBranch,updateEsicBranch,fetchEsicBranchList,deleteEsicBranch,} from '../../../../core/data/redux/payroll/ESIC/Master/Branch/branchAction';
import { Drawer, message } from 'antd';
import DeleteModal1 from '../../../../core/modals/deleteModal1';

const BranchModal: React.FC<any> = ({
  handleCancel,
  isModalVisible,
  modalType,
  selectedRowData,
  branchData,
  setBranchData,
  setTableKey,
  setIsDeleteModalVisible,
  isDeleteModalVisible,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector((state: any) => state.esic.branch);

  const [errors, setErrors] = useState<any>({});

  const resetForm = () => {
    setBranchData({
      branch_code: '',
      branch_name: '',
      branch_address: '',
      branch_contact: '',
    });
    setErrors({});
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    const value = e.target.value;
    setBranchData({ ...branchData, [field]: value });
    setErrors((prev: any) => ({ ...prev, [field]: '' }));
  };

  const validateForm = () => {
    let formIsValid = true;
    let newErrors: any = {};

    if (!branchData.branch_code) newErrors.branch_code = 'Branch Code is required.';
    if (!branchData.branch_name) newErrors.branch_name = 'Branch Name is required.';
    if (!branchData.branch_address) newErrors.branch_address = 'Branch Address is required.';
    if (!branchData.branch_contact) newErrors.branch_contact = 'Branch Contact is required.';

    if (Object.keys(newErrors).length > 0) {
      formIsValid = false;
    }
    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = { ...branchData };

    try {
      let result;
      if (modalType === 'create') {
        result = await dispatch(createEsicBranch(payload)).unwrap();
      } else if (modalType === 'edit' && selectedRowData) {
        result = await dispatch(
          updateEsicBranch({ id: selectedRowData.branch_id, ...payload })
        ).unwrap();
      }
      if (result) {
        message.success(result.message || 'Success');
        await dispatch(fetchEsicBranchList());
        setTableKey((prev: any) => prev + 1);
        resetForm();
        handleCancel();
      }
    } catch (error: any) {
      message.error(error.error || 'An error occurred');
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const result = await dispatch(deleteEsicBranch(id));
      if (result.meta.requestStatus === 'fulfilled') {
        message.success(result.payload.message || 'Deleted successfully');
        await dispatch(fetchEsicBranchList());
        setTableKey((prev: any) => prev + 1);
        setIsDeleteModalVisible(false);
      } else {
        message.warning(result.payload.error || 'Delete failed');
      }
    } catch {
      message.error('Something went wrong');
    }
  };

  return (
    <>
      <Drawer
        title={modalType === 'edit' ? 'Edit ESIC Branch' : 'Add ESIC Branch'}
        placement="right"
        width={600}
        onClose={() => {
          handleCancel();
          resetForm();
        }}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            {/* Branch Code */}
            <div className="mb-3">
              <label className="form-label">Branch Code <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={branchData.branch_code}
                onChange={(e) => handleInputChange(e, 'branch_code')}
              />
              {errors.branch_code && <div className="text-danger">{errors.branch_code}</div>}
            </div>

            {/* Branch Name */}
            <div className="mb-3">
              <label className="form-label">Branch Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={branchData.branch_name}
                onChange={(e) => handleInputChange(e, 'branch_name')}
              />
              {errors.branch_name && <div className="text-danger">{errors.branch_name}</div>}
            </div>

            {/* Branch Address */}
            <div className="mb-3">
              <label className="form-label">Branch Address <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={branchData.branch_address}
                onChange={(e) => handleInputChange(e, 'branch_address')}
              />
              {errors.branch_address && <div className="text-danger">{errors.branch_address}</div>}
            </div>

            {/* Branch Contact */}
            <div className="mb-3">
              <label className="form-label">Branch Contact <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={branchData.branch_contact}
                onChange={(e) => handleInputChange(e, 'branch_contact')}
              />
              {errors.branch_contact && <div className="text-danger">{errors.branch_contact}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white border me-2"
              onClick={() => {
                resetForm();
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === 'edit' ? 'Update Branch' : 'Add Branch'}
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedRowData?.branch_id && handleDelete(selectedRowData.branch_id)}
      />
    </>
  );
};

export default BranchModal;
